import { Box, Chip } from '@mui/material';
import type { AccessibilitySecurity } from '../api/security';
import {
    detailsCardChipSx,
    detailsCardHeaderSx,
    detailsCardSx,
    detailsRowSx,
    getSecurityTypeColor,
} from '../styles/chartReader.styles';
import {
    CardSubtitleTypography,
    CardTitleTypography,
    DetailLabelTypography,
    DetailValueTypography,
} from '../styles/chartReader.typography';

type SecurityDetailsCardProps = {
    security: AccessibilitySecurity;
};

type DetailRow = {
    label: string;
    value: string | undefined;
};

export function SecurityDetailsCard({ security }: SecurityDetailsCardProps) {
    const { ticker, ticker_full, name, /*exchange, region, cusip, isin,*/ security_type/*, category_name, holding_asset_class*/ } = security;
    const typeColor = getSecurityTypeColor(security_type);

    const rows: DetailRow[] = [
        // { label: 'Ticker',   value: ticker },
        // { label: 'Exchange', value: exchange },
        // { label: 'Region',   value: region },
        // { label: 'CUSIP',    value: cusip },
        // { label: 'ISIN',     value: isin },
        // { label: 'Category', value: category_name },
        // { label: 'Asset Class', value: holding_asset_class },
    ];

    return (
        <Box sx={detailsCardSx} role='region' aria-label='Selected security details'>
            {/* Header */}
            <Box sx={detailsCardHeaderSx}>
                <Box>
                    <CardTitleTypography>
                        {ticker_full || ticker}
                    </CardTitleTypography>
                    <CardSubtitleTypography sx={{ mt: 0.5 }}>
                        {name}
                    </CardSubtitleTypography>
                </Box>
                <Chip
                    label={security_type}
                    size='small'
                    sx={{
                        ...detailsCardChipSx,
                        backgroundColor: typeColor.bg,
                        color: typeColor.text,
                    }}
                />
            </Box>

            {/* Detail rows — only render rows that have a value */}
            {rows
                .filter((row) => Boolean(row.value))
                .map((row) => (
                    <Box key={row.label} sx={detailsRowSx}>
                        <DetailLabelTypography>{row.label}</DetailLabelTypography>
                        <DetailValueTypography>{row.value}</DetailValueTypography>
                    </Box>
                ))}
        </Box>
    );
}
